<template>
  <div class="project-team">
    <h3 class="title">父级项目</h3>
    <el-table :data="fatherData" style="width: 100%" v-loading="loading">
      <el-table-column prop="deptName" label="所属公司" width="180px">
      </el-table-column>
      <el-table-column prop="number" label="项目编号" width="120px">
      </el-table-column>
      <el-table-column prop="name" label="项目名称" width="200px">
      </el-table-column>
      <el-table-column prop="status" label="项目状态">
      </el-table-column>
      <el-table-column prop="leader.name" label="项目负责人">
      </el-table-column>
      <el-table-column prop="leader.mobile" label="联系方式">
      </el-table-column>

      <el-table-column label="操作" width="80px">
        <template slot-scope="scope">
          <router-link target="_blank" :to='"/Project/Detail/" + scope.row.id'>
            <el-button plain size="mini">详情</el-button>
          </router-link>
        </template>
      </el-table-column>
    </el-table>

    <h3 class="title" style="margin-top:20px;">子级项目</h3>
    <el-table :data="childData" style="width: 100%" v-loading="loading">
      <el-table-column prop="deptName" label="所属公司" width="180px">
      </el-table-column>
      <el-table-column prop="number" label="项目编号" width="120px">
      </el-table-column>
      <el-table-column prop="name" label="项目名称" width="200px">
      </el-table-column>
      <el-table-column prop="status" label="项目状态">
      </el-table-column>
      <el-table-column prop="leader.name" label="项目负责人">
      </el-table-column>
      <el-table-column prop="leader.mobile" label="联系方式">
      </el-table-column>

      <el-table-column label="操作" width="80px">
        <template slot-scope="scope">
          <router-link target="_blank" :to='"/Project/Detail/" + scope.row.id'>
            <el-button plain size="mini">详情</el-button>
          </router-link>
        </template>
      </el-table-column>
    </el-table>

  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";
  export default {
    props: ['projectId'],
    computed: {
      ...mapState({
        organization: state => state.main.organization,
      })
    },
    data() {
      return {
        // 列表
        loading: true,
        childData: [],
        fatherData: [],
      }
    },
    mounted() {
      // 获取列表
      this.getLists()
    },
    components: {},
    methods: {
      projectDetail(row) {
        console.log(row.id)
        this.$router.push("/Project/Detail/" + row.id)
      },
      // 获取列表
      getLists() {
        ajax.get('/gc/project/family/projects/' + this.projectId, '', (res) => {
          this.loading = false
          // this.filterData = this.listData = res.vo.array
          // this.getPaginationData()
          let _vo = res.vo
          // this.fatherData =  _v
          let _child = []
          for (var i = 0; i < _vo.children.length; i++) {
            if (_vo.children[i].id != this.projectId) {
              _child.push(_vo.children[i])
            }
          }
          this.childData = _child

          if (_vo.father) {
            this.fatherData.push(_vo.father)
          }
        })
      },
    },
    watch: {}
  };
</script>


// WEBPACK FOOTER //
// src/page/project/projectlist.vue